
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
// eslint-disable-next-line
import { Validation } from 'vuelidate' //Don't remove this import, otherwise validations isnt recognized
import Axios from 'axios'
import FormField from '../components/form-field.vue'
import { ANTIFORGERY_INPUT_NAME, BASE_URL } from '../helpers/constants'
import { APPLICATION_FIELDS, CV_FIELD, MOTIVATION_FIELD, CONSENT_FIELD } from '../helpers/form-constants'
import { getValidations, scrollToElement, setNecessaryFormFields } from '../helpers/functions'
import { IFormField } from '../types/forms'

@Component({
  validations() {
    return getValidations((this as ApplicationForm).formFields)
  },
  components: { FormField }
})
export default class ApplicationForm extends Vue {
  @Prop() vacancyPageId: string
  @Prop() applicationFormErrorMessage: string

  formFields: IFormField[] = APPLICATION_FIELDS

  model: { [key in string]: any } = {}

  loading = false

  isSent = false

  setFormData(): FormData {
    const antiForgeryInput: HTMLInputElement | null = document.querySelector(`input[name=${ANTIFORGERY_INPUT_NAME}]`)
    this.model[ANTIFORGERY_INPUT_NAME] = antiForgeryInput?.value
    if (this.vacancyPageId) this.model.vacancyPageId = this.vacancyPageId

    const formData = new FormData();
    for (const key in this.model) {
      formData.append(key, this.model[key]);
    }
    return formData
  }

  async send(): Promise<void> {
    this.$v.$touch()
    if (this.$v.$invalid) {
      this.$nextTick(() => scrollToElement(this.$el, '.error'))
      return
    }

    this.loading = true

    try {
      const formData = this.setFormData()
      const res: { data: { success: boolean } } = await Axios.post(`${BASE_URL}/applicationform/submit`,
        formData, { headers: { 'Content-Type': 'multipart/form-data' } })

      if (res.data.success) {
        this.isSent = true
        this.$nextTick(() => setTimeout(() => scrollToElement(this.$el, '.success-message'), 600))
      } else throw new Error()

    } catch (error) {
      console.error(error)
      this.$store.commit('notifications/add', { message: this.applicationFormErrorMessage })
    } finally {
      this.loading = false
    }
  }

  created(): void {
    setNecessaryFormFields(this, this.formFields)
  }
}
